import {loggedIn} from "./AuthActions";
import type {AppDispatch} from "../store";
import {fetchServicePrices} from "./ServicePriceActions";
import {persistentStorage} from "../utils/persistence-storage";

/**
 * Refresh login state (on app loading)
 */
export function refreshLoginState() {
  return async (dispatch: AppDispatch) => {
    const existingToken = persistentStorage.authToken.get()
    if (existingToken !== null) {
      console.info('Restoring existing session...')
      dispatch(loggedIn({token: existingToken}))
    }
  }
}

/**
 * Action that is called once user's authorization has been cleared
 * (i.e. user is authorized to use the app).
 */
export function useAuthorizationVerified() {
  return async (dispatch: AppDispatch) => {
    // Trigger data fetches after authorization has been cleared
    await dispatch(fetchServicePrices())
  }
}
